<template>
  <div class="bg-anthracite-700 text-white">
    <div
      class="mx-auto flex h-[90px] max-w-[1160px] items-center px-4 md:h-[82px] md:px-10"
    >
      <!-- Mobile: Swiper slider -->
      <div class="flex size-full items-center justify-center md:hidden">
        <Swiper
          :modules="[SwiperPagination, SwiperAutoplay]"
          :pagination="{
            clickable: true,
            renderBullet: (index, className) =>
              `<span class='promise-pagination-bullet ${className}'></span>`,
          }"
          :autoplay="{
            delay: 3000,
            disableOnInteraction: false,
          }"
          class="mt-2 h-[69px] w-full"
        >
          <SwiperSlide v-for="(promise, index) in promises" :key="index">
            <div class="flex justify-center">
              <SFFooterPromiseItem
                :title="promise.title"
                :description="promise.description"
                :icon="promise.icon"
              />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <!-- Desktop: Flex row -->
      <div
        class="hidden w-full justify-center md:flex md:flex-row md:items-center md:gap-x-8"
      >
        <SFFooterPromiseItem
          v-for="(promise, index) in promises"
          :key="index"
          :title="promise.title"
          :description="promise.description"
          :icon="promise.icon"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Swiper, SwiperSlide } from 'swiper/vue'
import {
  Autoplay as SwiperAutoplay,
  Pagination as SwiperPagination,
} from 'swiper/modules'
import SFFooterPromiseItem from './SFFooterPromiseItem.vue'
import 'swiper/css'
import 'swiper/css/pagination'

interface Promise {
  title: string
  description: string
  icon: string
}

const { t } = useI18n()

const promises: Promise[] = [
  {
    title: t('footer.promises.shipping.title'),
    description: t('footer.promises.shipping.description'),
    icon: 'IconSnipesDeliverytruck',
  },
  {
    title: t('footer.promises.returns.title'),
    description: t('footer.promises.returns.description'),
    icon: 'IconSnipesReturn',
  },
  {
    title: t('footer.promises.freeShipping.title'),
    description: t('footer.promises.freeShipping.description'),
    icon: 'IconSnipesDeliveryhomedelivery',
  },
]
</script>

<style scoped>
:deep(.swiper-pagination) {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 27px !important;
  gap: 4px !important;
}
:deep(.swiper-pagination .promise-pagination-bullet) {
  display: inline-block !important;
  width: 32px !important;
  height: 2px !important;
  border-radius: 2px !important;
  background: none !important;
  background-color: #6c6e71 !important; /* gray-400 */
  margin: 0 4px !important;
  transition: background-color 0.2s !important;
  box-shadow: none !important;
  opacity: 1 !important;
}
:deep(
    .swiper-pagination
      .swiper-pagination-bullet-active.promise-pagination-bullet
  ) {
  background: none !important;
  background-color: #fff !important;
}
</style>
